import React from "react";
import { Box, Tooltip } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";

export default function DownloadIconDesign({
  size = 30,
  color = "#4F46E5",
  onClick,
}) {
  return (
    <Tooltip title="Download PDF" arrow>
      <Box
        sx={{
          width: size,
          height: size,
          backgroundColor: color,
          borderRadius: "4px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: onClick ? "pointer" : "default",
          "&:hover": {
            backgroundColor: "#fff",
            border: "2px solid #4F46E5",
            "& .icon": {
              color: "#4F46E5",
            },
          },
        }}
        onClick={onClick}
      >
        <DownloadIcon
          className="icon"
          sx={{ color: "#fff", fontSize: size * 0.6 }}
        />
      </Box>
    </Tooltip>
  );
}
